import NavBar from '../Layout/NavBar.js'
import Header from '../../Components/Layout/Header';
import Title from '../../Components/Components/Title';
import ProjectsList from '../../Components/Layout/ProjectsList';
import Footer from '../../Components/Layout/Footer';
import { useTheme } from '@mui/material/styles';
import Model3DLayout from '../../Components/Layout/Model3DLayout';
import Model3DHappy from "../Components3D/Model3DHappy";

//Unity Asset Store
import ProjectsListHealthBar from "../../img/ProjectsList/UnityAssetStore/ProjectsList-Healthbar.jpg"
import ProjectsListDissolveShader from "../../img/ProjectsList/UnityAssetStore/ProjectsList-DissolveShader.jpg"
import ProjectsListPlatformerPack from "../../img/ProjectsList/UnityAssetStore/ProjectsList-PlatformerPack.jpg"
import ProjectsListStylizedShader from "../../img/ProjectsList/UnityAssetStore/ProjectsList-StylizedShader.jpg"
import ProjectsListTronShader from "../../img/ProjectsList/UnityAssetStore/ProjectsList-TronShader.jpg"
import ProjectsListWaterShader from "../../img/ProjectsList/UnityAssetStore/ProjectsList-WaterShader.jpg"
import ProjectsListToonRampShader from "../../img/ProjectsList/UnityAssetStore/ProjectsList-ToonRampShader.jpg"

//Gaming
import ProjectsListANewLeaf from "../../img/ProjectsList/Gaming/ANewLeaf.jpg"
import ProjectsListChubbyPixel from "../../img/ProjectsList/Gaming/ChubbyPixel.jpg"

//Web
import ProjectsListCubity from "../../img/ProjectsList/Web/Cubity.jpg"
import ProjectsListKreativa from "../../img/ProjectsList/Web/Kreativa.jpg"




function HomePage(){
  const theme = useTheme();

  const UnityAssetStoreList=[
    {
      "img":ProjectsListHealthBar,
      "href":"https://assetstore.unity.com/packages/slug/220222",
      "title":"Health Bar Billboard Shader - SRP URP"
    },
    {
      "img":ProjectsListDissolveShader,
      "href":"https://assetstore.unity.com/packages/tools/proximity-unlit-dissolve-portal-shader-174266",
      "title":"Proximity Unlit Dissolve Portal Shader"
    },
    {
      "img":ProjectsListPlatformerPack,
      "href":"https://assetstore.unity.com/packages/templates/packs/3d-platformer-starter-pack-183732",
      "title":"3D Platformer Starter Pack"
    },
    {
      "img":ProjectsListStylizedShader,
      "href":"https://assetstore.unity.com/packages/tools/stylized-toon-shader-184969",
      "title":"Stylized Toon Shader"
    },
    {
      "img":ProjectsListTronShader,
      "href":"https://assetstore.unity.com/packages/tools/unlit-tron-shader-mobile-ready-171011",
      "title": "Unlit Tron Shader - Mobile Ready"
    },
    {
      "img":ProjectsListWaterShader,
      "href":"https://assetstore.unity.com/packages/vfx/shaders/stylized-water-toon-shader-mobile-ready-165373",
      "title": "Stylized Water Toon Shader - Mobile Ready"
    },
    {
      "img":ProjectsListToonRampShader,
      "href":"https://assetstore.unity.com/packages/vfx/shaders/toon-ramp-shader-srp-urp-hdrp-216998",
      "title": "Toon Ramp Shader - SRP - URP - HDRP"
    }
  ]

  const GamingProjectsList=[
    {
      "img":ProjectsListANewLeaf,
      "redirect":"/gaming/anewleaf",
      "title":"A New Leaf"
    },
    {
      "img":ProjectsListChubbyPixel,
      "redirect":"/gaming/chubbypixel",
      "title":"Chubby Pixel Shaders"
    },
  ]

  const WebProjectsList=[
    {
      "img":ProjectsListCubity,
      "redirect":"/web/cubity",
      "title":"Cubity Website"
    },
    {
      "img":ProjectsListKreativa,
      "redirect":"/web/kreativa",
      "title":"Kreativa Website"
    },

  ]

  return(
    <div
      style={{

        background:`linear-gradient(0deg, ${theme.palette.quinary.main} 65%, ${theme.palette.tertiary.main} 65%, ${theme.palette.tertiary.main} 70%,  ${theme.palette.quaternary.main} 75%, rgba(299, 299, 299, 0.0) 100%)`
      }}
    >
      <NavBar></NavBar>
      <Header></Header>
      <Model3DLayout
        model3D={<Model3DHappy></Model3DHappy>}
        title={
          <Title
            title={"My skills"}
            titleColor={theme.palette.quinary.main}
            subTitle={"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, "}
            subTitleColor={theme.palette.quinary.main}
            id={'AssetStoreProjects'}
          ></Title>
        }
      ></Model3DLayout>
      <Title
        title={"Unity Asset Store Packages"}
        titleColor={theme.palette.secondary.main}
        subTitle={"A list of my unity asset store packages"}
        subTitleColor={theme.palette.secondary.main}
        id={'AssetStoreProjects'}
      ></Title>
      <ProjectsList
        data={UnityAssetStoreList}
      ></ProjectsList>
      <Title
        title={"Game Development"}
        titleColor={theme.palette.secondary.main}
        subTitle={"A list of games and unity projects I worked on"}
        subTitleColor={theme.palette.secondary.main}
        id={'AssetStoreProjects'}
      ></Title>
      <ProjectsList
        data={GamingProjectsList}
      ></ProjectsList>
      <Title
        title={"Web 3D Development"}
        titleColor={theme.palette.secondary.main}
        subTitle={"A list of 3D projects and website made with three js I worked on"}
        subTitleColor={theme.palette.secondary.main}
        id={'AssetStoreProjects'}
      ></Title>
      <ProjectsList
        data={WebProjectsList}
      ></ProjectsList>
      <Footer></Footer>
    </div>
  )
}
export default HomePage;